import { get, patch } from '../utils/api';

export const getNotifications = () => get(`/v3/activities`);
export const markNotificationsRead = (memberId, notificationId) =>
  patch(`/v2/members/${memberId}/activities/mark_as_read?before_including=${notificationId}`);
export const markSingleNotificationRead = (memberId, notificationId) =>
  patch(`/v3/activities/${notificationId}/mark_as_read`);
